import { PopoverContentProps } from '@chakra-ui/react';

export const Popover = {
  parts: ['popper'],
  baseStyle: (props: PopoverContentProps) => {
    return {
      popper: {
        zIndex: 100,
        maxW: props.width ? props.width : 'xs',
        w: '100%',
      },
    };
  },
  variants: {
    responsive: {
      content: {
        maxWidth: 'unset',
        width: 'unset',
      },
    },
  },
};
